import { Moment } from 'moment';
import { LOCALE } from '@stores/localeWeight';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { IImage } from '@interfaces/IImage';

export interface GameValue {
  label: string;
  value: string;
  image?: IImage;
}

export enum FEATURING_TYPE {
  STAGE_1 = 'STAGE_1',
  STAGE_2 = 'STAGE_2',
}

export interface FeaturingFormValue {
  id?: string;
  date: [Moment, Moment] | [null, null];
  postId: string;
  type: FEATURING_TYPE;
  locale: LOCALE | 'all';
  gameIds: GameValue[];
  platformIds: Array<CheckboxValueType>;
}
